__turbopack_context__.v({
  "colorFilter": "ColorFilter-module__Iu5Ytq__colorFilter",
  "listItem": "ColorFilter-module__Iu5Ytq__listItem",
});
